import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolderUpload: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFolderUpload"><Path d="M2 3H10.5352L12.5352 6H22V20H13V15.4142L14.5 16.9142L15.9142 15.5L12 11.5858L8.08579 15.5L9.5 16.9142L11 15.4142V20H2V3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFolderUpload;
